import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { AppAuthGuard } from './services/auth-guard/auth-guard.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { DateFormat } from 'src/app/models/date-format';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FilterComponent } from './components/filter/filter.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginatorIntl } from 'src/app/libraries/pagination';
import { DecimalRestrictionDirective } from './directives/decimal.directive';
import { NumericDirective } from './directives/numeric.directive';
import { RestrictDateDirective } from './directives/restrictdate.directive';
import { RestrictSearchDirective } from './directives/search.directive';
import { ErrorHandlerInterceptor } from './interceptor/error-handler.interceptor';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { DragAndDropDirective } from './directives/drag-and-drop.directive';
import { JwtInterceptor } from './interceptor/jwt.interceptor';
import { EmployeeSelectComponent } from './components/employee-select/employee-select.component';
import { WarningDialogComponent } from './modals/warning-dialog/warning-dialog.component';
import { MSAL_INSTANCE, MsalService } from '@azure/msal-angular';
import { initializeMsal, MSALInstanceFactory } from './utils/initializeMicrosoftLogin';
import { ExpenseReportComponent } from './components/expense-report/expense-report.component';
import { SearchTextPipe } from 'src/app/libraries/searchtext.pipe';
import { NgxPrintModule } from 'ngx-print';
import { OnlyWarningComponent } from './modals/only-warning/only-warning.component';

@NgModule({
  declarations: [FilterComponent, PaginationComponent, DecimalRestrictionDirective, NumericDirective, RestrictDateDirective, RestrictSearchDirective, FileUploadComponent, DragAndDropDirective, EmployeeSelectComponent, WarningDialogComponent, ExpenseReportComponent, SearchTextPipe, OnlyWarningComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    NgxPrintModule
  ],
  exports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FilterComponent,
    PaginationComponent,
    DecimalRestrictionDirective,
    NumericDirective,
    RestrictDateDirective,
    RestrictSearchDirective,
    FileUploadComponent,
    DragAndDropDirective,
    EmployeeSelectComponent,
    WarningDialogComponent,
    ExpenseReportComponent,
    SearchTextPipe,
    NgxPrintModule,
    OnlyWarningComponent
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: DateFormat },
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        AppAuthGuard,
        { provide: MAT_DATE_FORMATS, useValue: DateFormat },
      ],
    };
  }
}
